module.exports = __webpack_public_path__ + "img/b92248f.png";